import axios from 'axios';
import { getToken } from './authService';

const API_BASE = process.env.REACT_APP_API_BASE_URL || '/api';
const client = axios.create({ baseURL: API_BASE });
client.interceptors.request.use((cfg) => {
  const token = getToken();
  if (token) {
    cfg.headers = cfg.headers || {};
    cfg.headers.Authorization = `Bearer ${token}`;
  }
  return cfg;
});

export async function listSocialProfiles() {
  const { data } = await client.get('/social-profiles');
  return data.profiles || [];
}

export async function getSocialProfile(id) {
  const { data } = await client.get(`/social-profiles/${id}`);
  return data; // { profile, snapshots, posts }
}

export async function listSocialPosts(profileId, { withComments = false, limit = 30, onlyPolitical = false } = {}) {
  const params = { limit };
  if (withComments) params.with_comments = '1';
  if (onlyPolitical) params.only_political = '1';
  const { data } = await client.get(`/social-profiles/${profileId}/posts`, { params });
  return data.posts || [];
}

export async function runAiAnalysis({ postsLimit = 50, commentsLimit = 200 } = {}) {
  const { data } = await client.post('/social-posts/analyze', null, {
    params: { posts_limit: postsLimit, comments_limit: commentsLimit },
  });
  return data;
}

export async function fetchProfileComments(profileId, { limit = 5 } = {}) {
  const { data } = await client.post(`/social-profiles/${profileId}/fetch-comments`, null, {
    params: { limit },
  });
  return data;
}

export async function screenshotOcrComments(dummyAccountId, postUrl) {
  const { data } = await client.post(`/digital-profiles/${dummyAccountId}/screenshot-comments`, { post_url: postUrl });
  return data;
}

export async function listDummyAccountsForOcr() {
  const { data } = await client.get('/dummy-accounts');
  return (data.accounts || []).filter((a) => a.has_sessionid && a.status === 'active');
}

const socialService = { listSocialProfiles, getSocialProfile, listSocialPosts, fetchProfileComments };
export default socialService;
